import React, { useState } from 'react'
import Meses from '../services/Meses';

export default function ListarNoticias(props) {

  const cores = ['b-success', 'b-primary', 'b-secondary', 'b-warning', 'b-danger', ' b-greensea', 'b-lightred'];
  const [meses, setMes] = useState(Meses);

  return (
    <>
      <section className="content page-calendar" style={{ marginTop: '-30px' }}>
        <div className="container-fluid">
          <br />
          <div className="card col-md-12" >
            <div className="block-header">
              <div className="row">
                <div className="col-lg-7 col-md-6 col-sm-12">
                  {props.children}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="body" style={{ marginTop: '-50px' }}>
                  {props.publicacoes.map((publicacao, i) =>
                    <>
                      <hr />
                      <div className={`event-name row ${cores[i]}`} onClick={() => props.handlePublicacao(publicacao)} data-toggle="modal" data-target="#largeModalPublicacao" style={{ cursor: 'pointer' }} key={Math.random()}>
                        <div className="col-1 text-center">
                          <h4>
                            {publicacao.data_publicacao && publicacao.data_publicacao.split('-')[2]}
                            <span>
                              {publicacao.data_publicacao && meses.filter(mes => mes.id == publicacao.data_publicacao.split('-')[1])[0].mes}
                            </span>
                            <span>{new Date(publicacao.data_publicacao).getFullYear()}</span>
                          </h4>
                        </div>
                        <div className="col-10" >
                          <h6 style={{ textTransform: 'none' }}>{publicacao.titulo}</h6>
                          <p>{publicacao.resumo}</p>
                          <address><i className="zmdi zmdi-mouse"></i> Clique para ler na integra </address>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}